<app-error-item *ngFor="let error of errors$ | async as list" [error]="error" (onDismiss)="dismissError($event)">
</app-error-item>

<mat-card *ngIf="!(hasError$ | async)">
  No current errors
</mat-card>
